import { useTranslation } from "react-i18next";
import { Form, Grid, GridColumn } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";

import type { DealerDMSNextlaneConfig } from "models";
import type { AddEditDealerFormPayload } from "modules/DMSv3/Settings/components/AddEditDealerModal";

export type NextlaneConfig = Pick<DealerDMSNextlaneConfig, "dealership_id" | "api_key">;

const FormHelper = createFormHelper<AddEditDealerFormPayload>();

export const NextlaneConfigSection = () => {
  const { t } = useTranslation();

  return (
    <Grid columns="equal">
      <GridColumn>
        <Form.Field>
          <label>{t("v8_dealership_id", "Dealership ID")} </label>
          <FormHelper.Field.Input name="nextlane_config.dealership_id" inputProps={{ fluid: true }} />
        </Form.Field>
      </GridColumn>

      <GridColumn>
        <Form.Field>
          <label>{t("v8_api_key", "API Key")} </label>
          <FormHelper.Field.Input name="nextlane_config.api_key" inputProps={{ fluid: true }} />
        </Form.Field>
      </GridColumn>
    </Grid>
  );
};
